
import './ccf-available-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';
/* eslint-disable-next-line */
export interface CcfAvailableIconProps extends SvgIconProps  {}
/**
 * This icon will be used to display Available status of agent
 * @param props - CcfAvailableIconProps
 * @example - <CcfAvailableIcon />
 * @returns SVG of Available icon
 */
export function CcfAvailableIcon(props: CcfAvailableIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="ic_dropdown_Available" clipPath="url(#clip-ic_dropdown_Available)">
        <g id="ic_available" transform="translate(3 3)">
          <circle
            id="Ellipse_4745"
            data-name="Ellipse 4745"
            cx="9"
            cy="9"
            r="9"
            fill="#39c44a"
          />
          <path
            id="Path_25124"
            data-name="Path 25124"
            d="M1234.293,36.425l2.712,2.712,4.488-4.488"
            transform="translate(-1228.893 -27.45)"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfAvailableIcon;
